<template>
  <div class="content-area">

    <div class="page-content">
      <img v-if="imgShow" class="success-icon" src="@/assets/html5/icon_result_success@2x.png" alt="">
      <!-- <p class="nav-spec">{{$t('APP-FIELD-0134')}}</p> -->
      <p v-if="imgShow" class="nav-spec">{{$t('APP-FIELD-0134')}}</p>
      <p v-else class="nav-spec">{{$t('APP-FIELD-0154')}}</p>

      <p class="tips" v-if="!isPassword">{{$t('APP-FIELD-0203')}}</p>
      <p class="tips-4" v-if="!isPassword">{{$t('APP-FIELD-0204')}}</p>

      <div class="userid-box">
        <p class="title-text">{{title}}</p>
        <p class="value-text">{{content}}</p>
      </div>

      <p class="tips-2">Please take a screenshot to save the information</p>
      <!-- <SaveImage></SaveImage> -->

      <p class="tips-2" v-if="isPassword">{{$t('APP-FIELD-0135')}}</p>

      <p class="tips-1" :class="{'tips-3': !isPassword}">{{$t('APP-FIELD-0136')}}
        <span class="hot-line" @click="hotLineShow = true">{{$t('APP-FIELD-0137')}}</span>
      </p>

      <div class="bottom-wrap">
        <el-button v-if="isPassword" @click="$emit('on-next')">{{btnText}}</el-button>
        <el-button v-else @click="$emit('on-next')" type="primary">{{btnText}}</el-button>
      </div>
    </div>

    <services-hot-line v-model="hotLineShow" :agencyBanking="agencyBanking"></services-hot-line>

  </div>
</template>

<script>
  import ServicesHotLine from "../components/ServicesHotLine";
  // import SaveImage from "../components/SaveImage";

  export default {
    name: "SuccessIdAndPassword",
    components: {
      ServicesHotLine,
      // SaveImage
    },

    props: {
      imgShow: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: ""
      },
      content:{
        type: String,
        default: ""
      },
      isPassword: {
        type: Boolean,
        default: false
      },

      agencyBanking: {
        type: Boolean,
        default: false
      },

      btnText: {
        type: String,
        default: "Next"
      }
    },

    created() {
      this.isPassword ? this.mode= "bottom" : this.mode= "fixed"
    },

    data() {
      return {
        hotLineShow: false,
      }
    },

    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .content-area{
    padding: 0;
  }
  .page-content {
    text-align: center;
    /*width: 616px;*/
    margin: 93px auto 150px;

    .success-icon {
      margin: 20px 0;
      width: 77px;
    }

    .nav-spec {
      font-family: Nunito-Bold;
      font-size: 32px;
      color: #2C405A;
      letter-spacing: 0.16px;
      text-align: center;
      margin-bottom: 20px;
    }

    .tips {
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #2C405A;
      letter-spacing: 0.09px;
      text-align: center;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .userid-box {
      width: 380px;
      height: 120px;
      background: #E5F5FF;
      border-radius: 8px;
      margin: 30px auto 32px;
      padding: 24px 0 26px 0;

      .title-text {
        font-family: Nunito-Regular;
        font-size: 16px;
        color: #2C2C2C;
        letter-spacing: 0;
        text-align: center;
      }
      .value-text {
        font-family: Nunito-Bold;
        font-size: 24px;
        color: #2C2C2C;
        letter-spacing: 0;
        text-align: center;
        margin-top: 15px;
        font-weight: bold;
      }
    }

    .save-img-box {
      text-align: center;

      img {
        width: 24px;
        margin-right: 10px;
        vertical-align: middle;
      }

      span {
        font-family: Nunito-SemiBold;
        font-size: 16px;
        color: #0072D8;
        letter-spacing: 0.14px;
      }
    }

    .tips-1 {
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #2C405A;
      letter-spacing: 0.09px;
      margin: 20px auto;

    }

    .hot-line {
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #61C0FA;
      letter-spacing: 0.08px;
      text-align: center;
      line-height: 24px;
      cursor: pointer;
    }

    .tips-2{
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #2C405A;
      letter-spacing: 0.08px;
      text-align: center;
      line-height: 24px;
      margin: 20px auto ;
    }

    .tips-4{
      margin: 20px 0;
    }


    .el-button {
      width: 223px;
    }
  }
</style>